const login = document.querySelector('.login-modal');

if (null !== login) {
	if ('#login-form' === window.location.hash) {
		login.classList.add('login-modal--open');
	}

	const loginToggle = document.querySelectorAll(
		'.header-top__login, .paywall__login-link, .digital-edition__login'
	);
	const loginClose = document.querySelector('.login-modal__close');
	const mask = login.querySelector('.mask');
	const loginForm = document.querySelector('.login-modal__form');
	const closePopup = () => {
		login.classList.remove('login-modal--open');
		loginForm.reset();
	};

	loginToggle.forEach(function (btn) {
		btn.onclick = () => {
			login.classList.add('login-modal--open');
		};
	});

	loginClose.onclick = () => {
		closePopup();
	};

	mask.onclick = () => {
		closePopup();
	};

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') {
			return;
		}
		closePopup();
	});
}
